export const layeredSeriesThickness = (index: number) => _.max([80 - index * 20, 20]) as number
